import Marquee from "react-fast-marquee";
import { Trophy, Gift, Ticket, Phone, Sparkles } from "lucide-react";
import Reveal from "@/components/Reveal";

const ONAM_BG = "https://customer-assets-7cd3h4nn.emergentagent.net/job_konattu-interactive/artifacts/2cmjpamx_PRE%20ONAM%20MEET%20BG%20%282%29.webp";
const PRIZES = ["Televisions", "Washing Machines", "Refrigerators", "Smartphones", "Mixer Grinders", "& much more"];
const CARDS = [
  { icon: Trophy, title: "Daily Lucky Draws", body: "Every single day through the season, lucky Konattu shoppers win big. New winners, every day." },
  { icon: Gift, title: "Prizes Worth Winning", body: "TVs, washing machines, refrigerators, smartphones, mixer grinders and many more exciting rewards." },
  { icon: Ticket, title: "How To Enter", body: "Simply shop at any Konattu store during the offer, and every purchase enters you into the daily draw." },
];

export const MoodOffers = () => (
  <section id="offers" className="relative overflow-hidden py-24 md:py-32" data-testid="offers-section">
    <img src={ONAM_BG} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-konattu-red/90" />
    <div className="absolute inset-0 bg-gradient-to-b from-konattu-maroon/40 via-transparent to-konattu-maroon/50" />

    <div className="relative z-10">
      <div className="mb-16 border-y border-white/25 py-4 overflow-hidden">
        <Marquee speed={35} gradient={false} autoFill>
          <span className="font-display font-extrabold text-4xl md:text-6xl text-stroke-cream tracking-tightest px-8">ONAM MOOD OFFER</span>
          <span className="text-konattu-yellow text-3xl md:text-5xl px-2">★</span>
          <span className="font-display font-extrabold text-4xl md:text-6xl text-white tracking-tightest px-8">SEASON 2 · 2026</span>
          <span className="text-konattu-yellow text-3xl md:text-5xl px-2">★</span>
        </Marquee>
      </div>

      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-6">
          <Reveal>
            <span className="font-mono text-xs tracking-[0.35em] text-konattu-yellow">/ FESTIVE SEASON 2 · 2026</span>
            <h2 className="mt-5 font-display font-bold text-white tracking-tight leading-[0.95] text-4xl md:text-6xl max-w-3xl drop-shadow-sm">
              Konattu Onam Mood Offer.
            </h2>
            <p className="mt-5 font-body text-white/90 text-lg md:text-xl max-w-xl">
              Daily lucky draws, all season long. Shop and win, every single day.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <a href="tel:8086568787" data-testid="offers-call" className="group inline-flex items-center gap-3 bg-konattu-charcoal text-white px-8 py-4 text-sm font-medium tracking-wide hover:bg-black transition-colors whitespace-nowrap">
              <Phone size={16} /> Call now · 8086568787
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="flex flex-wrap gap-2.5 mb-14" data-testid="prize-list">
            {PRIZES.map((p) => (
              <span key={p} className="inline-flex items-center gap-2 bg-white/12 backdrop-blur-sm border border-white/25 text-white px-4 py-2 text-sm font-body">
                <Sparkles size={13} className="text-konattu-yellow" /> {p}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-4 md:gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.1}>
              <div data-testid={`offer-card-${i}`} className="group bg-konattu-cream h-full p-8 md:p-10 flex flex-col justify-between min-h-[300px] hover:bg-konattu-yellow transition-colors duration-500">
                <c.icon size={34} strokeWidth={1.25} className="text-konattu-red" />
                <div>
                  <h3 className="font-display font-bold text-2xl text-konattu-charcoal tracking-tight mb-3">{c.title}</h3>
                  <p className="font-body text-konattu-charcoal/75 text-[15px] leading-relaxed">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default MoodOffers;
